/* No blurred or tinted backdrop beyond a plain translucent ink layer. */
.overlay {
  position: fixed;
  inset: 0;
  z-index: var(--z-dialog);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-4);
  background: var(--scrim);
}

.overlay[data-entering] {
  animation: fade var(--dur) var(--ease);
}

.modal {
  width: 100%;
  max-width: 520px;
  max-height: calc(100vh - var(--space-7));
  overflow: auto;
  border-radius: var(--radius-float);
  background: var(--paper);
  box-shadow: var(--shadow-float);
}

.dialog {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  padding: var(--space-5);
  outline: none;
}

.dialog[data-tone='alert'] {
  border-top: 4px solid var(--danger);
  border-radius: var(--radius-float) var(--radius-float) 0 0;
}

.title {
  margin: 0;
  font: var(--t-heading);
}

.dialog[data-tone='alert'] .title {
  color: var(--danger);
}

.body {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: var(--space-3);
  margin-top: var(--space-2);
}

/* Phones: a full-screen sheet with the actions at the bottom, full width and stacked,
   the safe primary on top where the thumb reaches it first. */
@media (width < 640px) {
  .overlay {
    align-items: stretch;
    padding: 0;
  }

  .modal {
    display: flex;
    flex-direction: column;
    max-width: none;
    max-height: none;
    min-height: 100dvh;
    border-radius: 0;
  }

  .dialog {
    flex: 1;
    padding: var(--space-5) var(--gutter);
  }

  .body {
    flex: 1;
  }

  .dialog[data-tone='alert'] {
    border-radius: 0;
  }

  .actions {
    flex-direction: column-reverse;
    margin-top: auto;
    padding-top: var(--space-4);
  }

  .actions > * {
    width: 100%;
  }
}

@keyframes fade {
  from {
    opacity: 0;
  }
}
